import React from "react";
import { Navigate } from "react-router-dom";
import type { Capability } from "./permissions";
import { useAccess } from "./useAccess";
import type { AccessRequirementProps } from "./types";

export interface RequirePermissionProps extends AccessRequirementProps {
    children: React.ReactNode;
    fallback?: React.ReactNode;
    loadingFallback?: React.ReactNode;
    redirectTo?: string;
}

const requiredList = (required: RequirePermissionProps["required"]): readonly Capability[] => (typeof required === "string" ? [required] : required);

export const RequirePermission: React.FC<RequirePermissionProps> = ({
    required,
    children,
    fallback = <div role="alert">Access denied.</div>,
    loadingFallback = null,
    redirectTo,
    featureEnabled = true
}) => {
    const { hasAllPermissions, isLoading } = useAccess();

    if (featureEnabled && hasAllPermissions(requiredList(required))) {
        return <>{children}</>;
    }
    if (isLoading) return <>{loadingFallback}</>;
    if (redirectTo) return <Navigate to={redirectTo} replace />;
    return <>{fallback}</>;
};
